const VAT_KEY = 'giss_vat';

export const getVat = () => {
  const v = parseFloat(localStorage.getItem(VAT_KEY));
  return Number.isNaN(v) ? 19 : v;
};
export const setVat = (v) => localStorage.setItem(VAT_KEY, String(v));

export const vatSplit = (net, rate = getVat()) => {
  const vat = Math.round(net * rate) / 100;
  return { net, rate, vat, gross: net + vat };
};
